var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "#fff",
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M14.379 23.857c6.473 0 10.012-5.278 10.012-9.851q.002-.228-.007-.446a7.2 7.2 0 0 0 1.759-1.795 7.2 7.2 0 0 1-2.022.546 3.47 3.47 0 0 0 1.548-1.917 7.2 7.2 0 0 1-2.234.84 3.53 3.53 0 0 0-2.568-1.091c-1.942 0-3.518 1.55-3.518 3.46 0 .273.03.539.095.79a10.04 10.04 0 0 1-7.254-3.619 3.43 3.43 0 0 0-.475 1.738c0 1.2.62 2.262 1.57 2.88a3.5 3.5 0 0 1-1.592-.431v.043c0 1.68 1.212 3.073 2.825 3.396a3.6 3.6 0 0 1-1.591.057c.445 1.379 1.744 2.377 3.284 2.406A7.15 7.15 0 0 1 9 22.292a9.9 9.9 0 0 0 5.379 1.565",
    clipRule: "evenodd"
  })));
};
export default SvgTwitterinline;